import { queryOptions } from '@tanstack/react-query'

import { getFootballPlayerRelationships } from './api'

export const playerRelationshipQueryKeys = {
  all: ['football-player-relationships'] as const,
  detail: (apiSportsPlayerId: number, at?: string) => [
    ...playerRelationshipQueryKeys.all,
    apiSportsPlayerId,
    at ?? 'current',
  ] as const,
}

export function playerRelationshipQueryOptions(apiSportsPlayerId: number, at?: string) {
  return queryOptions({
    queryKey: playerRelationshipQueryKeys.detail(apiSportsPlayerId, at),
    queryFn: () => getFootballPlayerRelationships(apiSportsPlayerId, at),
    staleTime: 5 * 60 * 1000,
  })
}
